// 'use client';

// React Imports
import type { HTMLAttributes, ReactElement } from 'react';

// Hook Imports
import useVerticalNav from '../../hooks/useVerticalNav';

import { Box } from '@mui/material';
import { TIPS } from '../../../../../constants';
// Icon Imports
import CloseIcon from '../../svg/Close';
import RadioCircleIcon from '../../svg/RadioCircle';
import RadioCircleMarkedIcon from '../../svg/RadioCircleMarked';

type NavCollapseIconsProps = HTMLAttributes<HTMLSpanElement> & {
  closeIcon?: ReactElement;
  lockedIcon?: ReactElement;
  unlockedIcon?: ReactElement;
  onClick?: () => void;
  onClose?: () => void;
};

const NavCollapseIcons = (props: NavCollapseIconsProps) => {
  // Props
  const { closeIcon, lockedIcon, unlockedIcon, onClick, onClose, ...rest } = props;

  // Hooks
  const { isCollapsed, collapseVerticalNav, isBreakpointReached, toggleVerticalNav } = useVerticalNav();

  // Handle Lock / Unlock Icon Buttons click
  const handleClick = (action: 'lock' | 'unlock') => {
    // Setup the verticalNav to be locked or unlocked
    const collapse = action !== 'lock';

    // Tell the verticalNav to lock or unlock
    collapseVerticalNav(collapse);

    // Call onClick function if passed
    onClick?.();
  };

  // Handle Close button click
  const handleClose = () => {
    // Close verticalNav using toggle verticalNav function
    toggleVerticalNav(false);

    // Call onClose function if passed
    onClose?.();
  };

  return (
    <>
      {isBreakpointReached ? (
        <span
          data-tour={TIPS.LAYOUT.SIDEBAR.VERTICAL_MENU_CLOSE_ICON.DATA}
          role="button"
          tabIndex={0}
          style={{ display: 'flex', cursor: 'pointer' }}
          onClick={handleClose}
          {...rest}
        >
          {closeIcon ?? <CloseIcon />}
        </span>
      ) : isCollapsed ? (
        <span
          role="button"
          tabIndex={0}
          style={{ display: 'flex', cursor: 'pointer' }}
          onClick={() => handleClick('lock')}
          {...rest}
        >
          {unlockedIcon ?? <RadioCircleIcon />}
        </span>
      ) : (
        <span
          role="button"
          tabIndex={0}
          style={{ display: 'flex', cursor: 'pointer' }}
          onClick={() => handleClick('unlock')}
          {...rest}
        >
          {lockedIcon ?? <RadioCircleMarkedIcon />}
        </span>
      )}
    </>
  );
};

export default NavCollapseIcons;
